import { autocomplete, lookupUdprn, lookupUmprn, } from "@ideal-postcodes/core-axios";
/**
 * @hidden
 */
export class ApiCache {
    constructor(client) {
        this.prefix = "!";
        this.client = client;
        this.cache = {};
    }
    key(query) {
        return `${this.prefix}${query.toLowerCase()}`;
    }
    retrieve(query) {
        return this.cache[this.key(query)];
    }
    store(query, data) {
        this.cache[this.key(query)] = data;
        return data;
    }
    clear() {
        this.cache = {};
    }
    /**
     * Retrieve a list of address suggestions given a query
     *
     * Write and read from cache if previously requested
     */
    query(query, options = {}) {
        const cachedValue = this.retrieve(query);
        if (cachedValue)
            return Promise.resolve(cachedValue);
        const p = autocomplete
            .list(this.client, {
            query: {
                query,
                api_key: this.client.config.api_key,
                ...options,
            },
        })
            .then((response) => {
            const suggestions = response.body.result.hits;
            this.store(query, suggestions);
            return suggestions;
        });
        this.store(query, p);
        return p;
    }
    resolve(suggestion) {
        const { umprn, udprn } = suggestion;
        if (umprn !== undefined)
            return lookupUmprn({ client: this.client, umprn });
        return lookupUdprn({ client: this.client, udprn });
    }
}
